import React, { useMemo } from 'react'

import { convertToIconString } from 'common/builder/components/chart/FlowChart/lib/utils/convertToIconString'
import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { FlowChartButton } from 'common/builder/components/chart/FlowChart/types/FlowChartButton'

import * as styles from './ButtonIcon.styles'

interface ButtonInfoProps {
  button: FlowChartButton
  style?: React.CSSProperties
}

export const ButtonIcon = ({ button, style: externalStyle }: ButtonInfoProps) => {
  const IconComponent = button.icon
  const iconString = useMemo(
    () =>
      IconComponent &&
      convertToIconString(IconComponent, {
        color: sharedStyles.Colors.PRIMARY,
        size: sharedStyles.IconSizes.MEDIUM * 2,
      }),
    [IconComponent],
  )

  if (!iconString) {
    return null
  }

  const style = {
    ...styles.iconSpriteStyle,
    ...externalStyle,
  }

  return <sprite style={style} image={iconString} />
}
